<app-page-content class="independent-scroll-page">
<app-doenkids-menu-bar menuBar [showBackButton]="true" [loading]="loading$ | async">
  <div class="flex-row items-center justify-start" left>
    @if (hasWriteAccess$ | async) {
      <button
        [disabled]="!isTheOwner"
        mat-icon-button
        type="button"
        (click)="save()"
        [matTooltip]="'program.template_preview.save.tooltip' | translate"
      >
        <mat-icon>save</mat-icon>
      </button>
    }
    @if (!(baseOnly$ | async) && !(isReader$ | async)) {
      <button
        mat-icon-button
        type="button"
        (click)="editProgram()"
        [matTooltip]="'program.template_preview.edit.tooltip' | translate"
        [disabled]="!(hasWriteAccess$ | async) || !isTheOwner"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
    @if (!(showMobileLayout$ | async)) {
      @if (programTemplateOwner$ | async; as owner) {
        <app-owner-chip
          [(isTheOwner)]="isTheOwner"
          (isTheOwnerChange)="handleIsTheOwnerChange($event)"
          [owningOuId]="owner.organization_unit_id"
        ></app-owner-chip>
      }
    }
    @if (!(isReader$ | async) && (isLocation$ | async) && !(baseOnly$ | async)) {
      <button
        mat-icon-button
        type="button"
        (click)="createProgram()"
        [matTooltip]="'program.template_preview.create.tooltip' | translate"
      >
        <mat-icon>date_range</mat-icon>
      </button>
    }
    <button mat-icon-button type="button" (click)="downloadPDF()" matTooltip="Download PDF" [disabled]="!(programTemplate$ | async)?.media_uuid">
      <mat-icon>get_app</mat-icon>
    </button>
    <button mat-icon-button type="button" (click)="downloadPoster()" matTooltip="Download Poster">
      <mat-icon>photo-album</mat-icon>
    </button>
    @if (!(isReader$| async) && (baseOnly$ | async) && !(isApproved$ | async) && (canBeApproved$ | async) && !(approveIsTranslate$ | async)) {
      <button
        mat-icon-button
        type="button"
        (click)="approveTemplate()"
        [matTooltip]="'program.template_preview.approve.tooltip' | translate"
      >
        <mat-icon>done_all</mat-icon>
      </button>
    }
    @if (!(isReader$| async) && !(hasWriteAccess$ | async) && (isApproved$ | async)) {
      <button
        color="primary"
        mat-icon-button
        type="button"
        (click)="removeApproval()"
        [matTooltip]="'program.template_preview.approval.revoke.tooltip' | translate"
      >
        <mat-icon>done_all</mat-icon>
      </button>
    }
    @if (!(isReader$| async) && (canBeForked$ | async) && !(approveIsTranslate$ | async)) {
      <button mat-icon-button type="button" (click)="forkTemplate()" [matTooltip]="'program.template_preview.fork.tooltip' | translate">
        <mat-icon class="icon-btn">call_split</mat-icon>
      </button>
    }
    @if (!(isReader$| async) && (approveIsTranslate$ | async)) {
      <button
        mat-icon-button
        (click)="forkTemplate(true)"
        [matTooltip]="'program_template_preview.translate.tooltip' | translate"
      >
        <mat-icon>translate</mat-icon>
      </button>
    }
    @if (possibleContentLanguages$ | async; as contentLanguages) {
      @if (!(baseOnly$ | async) && (hasWriteAccess$ | async) && contentLanguages?.length > 1) {
        <mat-form-field
          appearance="outline"
          class="compact-select content-language-select"
        >
          <mat-label>{{ 'program_template.content_language.label' | translate }}</mat-label>
          <mat-select [formControl]="contentLanguageControl">
            @if (contentLanguageControl.value) {
              <mat-select-trigger>
                <mat-icon [svgIcon]="contentLanguageControl.value.toLowerCase()"></mat-icon>
                {{ 'generic.language.' + contentLanguageControl.value.toLowerCase() | translate }}
              </mat-select-trigger>
            }
            @for (contentLanguage of contentLanguages; track contentLanguage) {
              <mat-option [value]="contentLanguage">
                <mat-icon [svgIcon]="contentLanguage.toLowerCase()"></mat-icon>
                {{ 'generic.language.' + contentLanguage.toLowerCase() | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    }
  </div>
  <div right class="flex-1 flex-row items-center justify-end gap-2">
    @if (!(showMobileLayout$ | async)) {
      @if (!(baseOnly$ | async) && (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async) && (programTemplate$ | async)?.program_template_status_id; as statusId) {
        <app-status-chip
          [statusName]="getProgramTemplateStatusName(statusId)"
          [translationKey]="'program.status.' + getProgramTemplateStatusName(statusId)"
        ></app-status-chip>

        @if ((hasWriteAccess$ | async) && isTheOwner) {
          <app-publish-button
            [currentStatusName]="getProgramTemplateStatusName(statusId)"
            [hasWriteAccess]="(hasWriteAccess$ | async) && isTheOwner"
            [statusOptions]="getTemplateStatusOptionsForMenu(statusId)"
            [publishTooltip]="getProgramTemplateStatusName(statusId) === 'published' ? ('program_details.status.already_published' | translate) : ('program.status.publish' | translate)"
            [optionsTooltip]="'program.status.options' | translate"
            menuId="templateStatusOptionsMenu"
            (publish)="publishTemplate()"
            (statusSelected)="changePublicationStatus($event)"
          ></app-publish-button>
        }
      }
    }

    @if (
      !(isRevoked$ | async) &&
      ((isAdmin$ | async) || ((!(isRootNode$ | async) || (baseOnly$ | async)) && (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)))
    ) {
      <button
        mat-icon-button
        type="button"
        (click)="excludeProgramTemplate()"
        [matTooltip]="'program.template_preview.exclude.tooltip' | translate"
      >
        <mat-icon>remove_circle</mat-icon>
      </button>
    }
    @if (hasWriteAccess$ | async) {
      <button
        mat-icon-button
        type="button"
        (click)="removeProgramTemplate()"
        [disabled]="!isTheOwner"
        [matTooltip]="'program.template_preview.delete.tooltip' | translate"
      >
        <mat-icon>delete</mat-icon>
      </button>
    }
  </div>
</app-doenkids-menu-bar>
<div content>

<app-split-page
  #splitPage
  [leftLabel]="'activity.preview.tab.details' | translate"
  [rightLabel]="'activity.preview.tab.preview' | translate"
  [activeTab]="0"
  [independentScroll]="true"
  (selectedTabChange)="tabChange($event)"
>
  <ng-template #left>
    @if (showMobileLayout$ | async) {
      @if (programTemplate$ | async; as programTemplate) {
        <div class="mobile-chips-section">
          <div class="flex-row items-center justify-start flex-wrap gap-2">
            @if (programTemplateOwner$ | async; as owner) {
              <app-owner-chip
                [(isTheOwner)]="isTheOwner"
                (isTheOwnerChange)="handleIsTheOwnerChange($event)"
                [owningOuId]="owner.organization_unit_id"
              ></app-owner-chip>
            }
            @if (!(baseOnly$ | async) && (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async) && programTemplate.program_template_status_id; as statusId) {
              <app-status-chip
                [statusName]="getProgramTemplateStatusName(statusId)"
                [translationKey]="'program.status.' + getProgramTemplateStatusName(statusId)"
              ></app-status-chip>
              @if ((hasWriteAccess$ | async) && isTheOwner) {
                <app-publish-button
                  [currentStatusName]="getProgramTemplateStatusName(statusId)"
                  [hasWriteAccess]="(hasWriteAccess$ | async) && isTheOwner"
                  [statusOptions]="getTemplateStatusOptionsForMenu(statusId)"
                  [publishTooltip]="getProgramTemplateStatusName(statusId) === 'published' ? ('program_details.status.already_published' | translate) : ('program.status.publish' | translate)"
                  [optionsTooltip]="'program.status.options' | translate"
                  menuId="templateStatusOptionsMenuMobile"
                  (publish)="publishTemplate()"
                  (statusSelected)="changePublicationStatus($event)"
                ></app-publish-button>
              }
            }
          </div>
        </div>
      }
    }
    @if (programTemplate$ | async; as programTemplate) {
      <div class="details flex-col" [formGroup]="programTemplateForm">
      <div class="main-details flex-col lg-flex-row items-start justify-start gap-4">
        <div class="template-image-block">
          @if (hasWriteAccess$ | async) {
            <app-asset-upload
              [class.full-width]="isSmall$ | async"
              identifier="template-cover"
              purpose="program-template"
              (uploaded)="addCoverImage($event)"
            >
            <ng-template let-uploadData="uploadData">
              <div class="image-container">
                <app-doenkids-image
                  [maxHeight]="500"
                  [maxWidth]="500"
                  [preview]="true"
                  [showOriginType]="true"
                  [mediaItem]="this.programTemplateForm.get('coverImage').value"
                >
                  <app-select-media
                    identifier="template-cover"
                    [uploadData]="uploadData"
                    [removable]="this.programTemplateForm.get('coverImage').value"
                    (selected)="addCoverImage($event)"
                    purpose="program-template"
                  >
                  </app-select-media>
                </app-doenkids-image>
              </div>
            </ng-template>
          </app-asset-upload>
          }
          @if (!(hasWriteAccess$ | async)) {
            <app-doenkids-image
              [maxHeight]="500"
              [maxWidth]="500"
              [mediaItem]="programTemplate.media_uuid"
              [showOriginType]="true"
            ></app-doenkids-image>
          }
          @if ((hasWriteAccess$ | async) && programTemplate.media_uuid) {
            <div class="template-poster-toggle">
              <mat-checkbox
                [formControl]="includePosterControl"
                (change)="toggleIncludePoster($event.checked)"
                >
                {{ 'program_details.include_poster' | translate }}
              </mat-checkbox>
            </div>
          }
        </div>
        <div class="template-details">
          @if (!(hasWriteAccess$ | async)) {
            <div class="flex-col">
              <ng-template [ngTemplateOutlet]="okoTypeDisplay"></ng-template>
              <h1 class="title">{{ programTemplate.name }}</h1>
              @if (getDurationLabels(programTemplate.intended_duration); as intentedDuration) {
                <h2>
                  {{ intentedDuration | translate }}
                </h2>
              }
            <div class="content" [innerHTML]="programTemplate.content"></div>
            <div class="download-buttons flex-row gap-4">
              <button mat-flat-button color="primary" type="button" (click)="downloadPDF()">{{ 'program_details.pdf.download' | translate }}</button>
              <button mat-flat-button color="primary" type="button" (click)="downloadPoster()">
                {{ 'program.template_preview.poster.download.label' | translate }}
              </button>
              @if ((hasProgramExplanationPermission$ | async) && (programExplanationAttachmentList$ | async)?.length > 0) {
                @for (attachment of programExplanationAttachmentList$ | async; track attachment) {
                  <button mat-flat-button color="primary" type="button" (click)="downloadAttachment(attachment, $event)">
                    {{
                      'program.template_preview.attachment.download.label'
                        | translate
                          : {
                              filename: attachment.display_name ? attachment.display_name : attachment.filename
                            }
                    }}
                  </button>
                }
              }
              @if ((programAttachmentList$ | async)?.length > 0) {
                @for (attachment of programAttachmentList$ | async; track attachment; let index = $index) {
                  @if (index < currentTemplateAttachmentLimit) {
                    <button mat-flat-button color="primary" type="button" (click)="downloadAttachment(attachment, $event)">
                      {{
                        'program.template_preview.attachment.download.label'
                          | translate
                            : {
                                filename: attachment?.display_name ?? attachment?.filename ?? ''
                              }
                      }}
                    </button>
                  }
                }
              }
              @if ((programAttachmentList$ | async)?.length > currentTemplateAttachmentLimit) {
                <button mat-flat-button color="primary" type="button" (click)="loadMoreAttachments()">...</button>
              }
            </div>
          </div>
          }
          @if (hasWriteAccess$ | async) {
            <div class="form-fields">
              <mat-form-field appearance="outline" [class.full-width]="isSmall$ | async">
                <mat-label>{{ 'program.template_preview.name.label' | translate }}</mat-label>
                <input matInput formControlName="name" />
              </mat-form-field>
              <mat-form-field appearance="outline" [class.full-width]="isSmall$ | async">
                <mat-label>{{ 'program.template_preview.category.label' | translate }}</mat-label>
                <mat-select formControlName="category" [placeholder]="'program.template_preview.category.placeholder' | translate">
                  @for (category of programCategories$ | async; track category.id) {
                    <mat-option [value]="category.id">{{ category.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if ((okoTypes$ | async)?.length > 1) {
                <div>
                  <mat-form-field appearance="outline" [class.full-width]="isSmall$ | async">
                    <mat-label>{{ 'program.template_preview.activity_type.label' | translate }}</mat-label>
                    <mat-select formControlName="typeOko">
                      @for (okoType of okoTypes$ | async; track okoType.id) {
                        <mat-option [value]="okoType.id">{{ okoType.name | uppercase }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              } @else {
                <ng-template [ngTemplateOutlet]="okoTypeDisplay"></ng-template>
              }
            </div>
            <div class="template-content">
              <span class="template-content-title">
                {{ 'program.template_preview.content.label' | translate }}
              </span>
              <div class="editing-content">
                <quill-editor
                  bounds="self"
                  theme="bubble"
                  formControlName="content"
                  appOnFocus
                  [placeholder]="'program.template_preview.content.placeholder' | translate"
                ></quill-editor>
              </div>
            </div>
            <div class="template-tags">
              <span class="template-tags-title">
                {{ 'program.template_preview.tags.label' | translate }}
              </span>
              <tag-input
                formControlName="tags"
                [onlyFromAutocomplete]="true"
                displayBy="name"
                identifyBy="id"
                [placeholder]="'program.template_preview.tags.placeholder' | translate"
                [secondaryPlaceholder]="'program.template_preview.tags.secondary_placeholder' | translate"
                [disable]="programTemplateForm.get('tags')?.disabled ?? false"
              >
                <tag-input-dropdown
                  [showDropdownIfEmpty]="true"
                  [autocompleteItems]="allTags$ | async"
                  displayBy="name"
                  identifyBy="id"
                  [keepOpen]="false"
                  [appendToBody]="false"
                >
                  <ng-template let-item="item" let-index="index">
                    <div class="tag">
                      @if (item.organization_unit_id === (currentOUId$ | async)) {
                        <mat-icon>push_pin</mat-icon>
                      }
                      <span>
                        {{ item.name }}
                      </span>
                    </div>
                  </ng-template>
                </tag-input-dropdown>
              </tag-input>
            </div>
          }

          <ng-template #okoTypeDisplay>
            <div>
              <span>{{ 'program.template_preview.suitable_for.label' | translate }}</span
              >&nbsp;
              <span>{{ (programActivityType$ | async)?.name }}</span>
            </div>
          </ng-template>
        </div>
      </div>

      @if ((hasProgramExplanationPermission$ | async) && (hasWriteAccess$ | async)) {
        <div class="attachments">
          <h2 class="title">
            <span>{{ 'program.template_preview.explanations.heading' | translate }}</span>
            @if (isTheOwner) {
              <button mat-button (click)="addExplanationAttachment()">
                <mat-icon>note_add</mat-icon>
                {{ 'generic.upload' | translate | lowercase }}
              </button>
            }
          </h2>
          <mat-divider></mat-divider>
          <div class="attachment-container">
            @for (attachment of programExplanationAttachmentList$ | async; track attachment) {
              <div
                class="attachment flex-row justify-between items-center"
                (click)="editAttachment(attachment, $event)"
              >
                <div class="flex-row items-center justify-start">
                  <mat-icon>attachment</mat-icon>&nbsp;&nbsp; <span>{{ attachment.display_name ? attachment.display_name : attachment.filename }}</span
                  >&nbsp;
                  <span> — ({{ attachment.created_at | i18n_date : 'dd/MM/yyyy' | async }})</span>
                </div>
                @if (isTheOwner) {
                  <button mat-icon-button type="button" (click)="removeAttachment($event, attachment)">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </div>
            }
          </div>
        </div>
      }

      @if (hasWriteAccess$ | async) {
        <div class="attachments">
          <div class="flex-row justify-between items-center">
            <h2 class="title">
              {{ 'program.template_preview.attachments.heading' | translate }}
            </h2>
            @if (isTheOwner) {
              <button
                class="attachment-upload-button"
                mat-icon-button
                type="button"
                (click)="addAttachment()"
                [matTooltip]="'generic.upload' | translate"
              >
                <mat-icon>note_add</mat-icon>
              </button>
            }
          </div>
          <mat-divider></mat-divider>
          <div class="attachment-container">
            @for (attachment of programAttachmentList$ | async; track attachment) {
              <div
                class="attachment flex-row justify-between items-center"
                (click)="previewAttachment(attachment)"
              >
                <div class="flex-row items-center justify-start">
                  <mat-icon>attachment</mat-icon>&nbsp;&nbsp; <span>{{ attachment.display_name ? attachment.display_name : attachment.filename }}</span
                  >&nbsp;
                  <span> — ({{ attachment.created_at | i18n_date : 'dd/MM/yyyy' | async }})</span>
                </div>
                <div class="attachment-buttons flex-row justify-end">
                  @if (isTheOwner) {
                    <button
                      mat-icon-button
                      type="button"
                      (click)="downloadAttachment(attachment, $event)"
                      [matTooltip]="'generic.download' | translate"
                    >
                      <mat-icon>download</mat-icon>
                    </button>
                  }
                  @if (isTheOwner) {
                    <button
                      mat-icon-button
                      type="button"
                      (click)="editAttachment(attachment, $event)"
                      [matTooltip]="'program.template_preview.update_name.tooltip' | translate"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                  }
                  @if (isTheOwner) {
                    <button
                      mat-icon-button
                      type="button"
                      (click)="removeAttachment($event, attachment)"
                      [matTooltip]="'generic.delete' | translate"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }

      @for (period of periods$ | async; track period; let isLast = $last) {
        <div class="periods flex-fill">
          <h2>{{ period.period_type === 'FREEFORM' ? period.name : (period.start_date | i18n_date : 'fullDate' | async | titlecase) }}</h2>
          @if (period?.subtitle) {
            <h3>{{ period.subtitle }}</h3>
          }
          @if (period?.summary) {
            <div [innerHTML]="period.summary | textToList"></div>
          }
          @if (getPeriodSections(period.id); as periodSections) {
            @for (periodSection of periodSections; track periodSection) {
              @if (periodSection?.data; as sectionData) {
                <div
                  class="period_section period-section flex-fill"
                  (click)="navigateToActivity(periodSection)"
                >
                  @if (
                    !titleIsNil(sectionData.title) ||
                    (sectionData.customer_symbol && sectionData.customer_symbol.length > 0 && (hasCustomerSymbolPermission$ | async))
                  ) {
                    <h4 class="section_title">
                      @if (!titleIsNil(sectionData.title)) {
                        <span>{{ sectionData.title }}</span>
                      }
                      @if (sectionData.customer_symbol && sectionData.customer_symbol.length > 0 && (hasCustomerSymbolPermission$ | async)) {
                        <div class="symbol-list">
                          @for (symbolId of sectionData.customer_symbol; track symbolId) {
                            @if (fetchedCustomerSymbols$ | async; as symbols) {
                              @if (symbols[symbolId]; as fetchedSymbol) {
                                <app-doenkids-image
                                  [maxWidth]="40"
                                  [maxHeight]="40"
                                  [preview]="false"
                                  [mediaItem]="{ uuid: fetchedSymbol.media_uuid, description: '' }"
                                ></app-doenkids-image>
                              }
                            }
                          }
                        </div>
                      }
                    </h4>
                  }
                  <div class="flex-row gap-4 flex-fill">
                    @if (sectionData.media_uuid) {
                      <app-doenkids-image
                        class="wrapped-image"
                        [mediaItem]="sectionData.media_uuid"
                        [maxHeight]="100"
                        [maxWidth]="100"
                      >
                      </app-doenkids-image>
                    }
                    <div class="flex-col gap-4">
                      @if (sectionData.subtitle) {
                        <h5>{{ sectionData.subtitle }}</h5>
                      }

                      @if (periodSection?.type_id === EProgramPeriodSectionType.ACTIVITY) {
                        @if (sectionData.timeslot) {
                          <h6>{{ sectionData.timeslot }}</h6>
                        }
                        @if (sectionData.content) {
                          <p>{{ sectionData.content }}</p>
                        }
                      }
                    </div>
                  </div>

                  @switch (periodSection?.type_id) {
                    @case (EProgramPeriodSectionType.ACTIVITY) {
                      @if (sectionData.additional_content) {
                        <i>{{ sectionData.additional_content }}</i>
                      }
                    }

                    @case (EProgramPeriodSectionType.MEDIA) {
                      <div class="media-container">
                        @for (media of sectionData.media; track media) {
                          @if (media?.uuid) {
                            <mat-card appearance="outlined" class="media-item flex-col">
                              <app-doenkids-image [maxHeight]="150" [maxWidth]="150" [mediaItem]="media?.uuid" class="media-image"> </app-doenkids-image>
                              @if (media.description) {
                                <i>{{ media.description }}</i>
                              }
                            </mat-card>
                          }
                        }
                      </div>
                    }

                    @case (EProgramPeriodSectionType.ACTIVITY_WHAT) {
                      @if (sectionData?.content) {
                        <div [innerHTML]="sectionData.content" class="ql-editor"></div>
                      }
                    }

                    @case (EProgramPeriodSectionType.BANNER) {
                      @if (sectionData?.media?.length && sectionData.media[0]?.uuid) {
                        <div class="banner-container">
                          <app-doenkids-image
                            class="banner-image"
                            [mediaItem]="sectionData.media[0]?.uuid"
                          ></app-doenkids-image>
                          @if (sectionData.media[0]?.caption) {
                            <p class="banner-caption">{{ sectionData.media[0]?.caption }}</p>
                          }
                        </div>
                      }
                    }
                  }
                </div>
              }
            }
          }
          @if (!isLast) {
            <hr />
          }
        </div>
      }
        <br />
      </div>
    }
  </ng-template>

  <ng-template #right>
    <div class="pdf-container">
      <app-pdf-viewer
        [pdfSrc]="pdf$ | async"
        [loading]="pdfLoading$ | async"
        (pdfLoaded)="onPdfLoadedEvent()"
      ></app-pdf-viewer>
    </div>
  </ng-template>
</app-split-page>

</div>
</app-page-content>
